export const isEmail = (value) => /^\S+@\S+\.[a-zA-Z]{2,}$/.test(value);

export const isNumber = /^-?\d+(\.\d+)?$/;
